import { AS } from "../lib/siteStatus";

export default function Maintenance() {
  return (
    <main
      data-testid="maintenance-page"
      className="min-h-screen flex items-center"
      style={{ background: AS.bg, color: AS.text }}
    >
      <section className="mx-auto w-full max-w-5xl px-5 sm:px-8">
        <h1
          data-testid="maintenance-title"
          className="text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.08] tracking-[-.04em]"
        >
          AnswerStrike Academy
        </h1>
        <p
          data-testid="maintenance-message"
          className="mt-5 text-lg leading-relaxed border-t pt-5 max-w-3xl"
          style={{ color: AS.muted, borderColor: AS.border }}
        >
          Private client training. Access by invitation.
        </p>
      </section>
    </main>
  );
}
